// extracted by mini-css-extract-plugin
export default {"authTemplate":"authtemplate_authTemplate__lNei6","authImage":"authtemplate_authImage__1ttwd","authForm":"authtemplate_authForm__3m8lr"};